module.exports = __webpack_public_path__ + "img/esteelauder_logo_footer.eb540049.png";